<template>
  <v-app class="web login-page">

    <!-- =======================================================
                              Overlay
    ============================================================-->
    <v-overlay :value="overlay">
      <v-progress-circular :size="70" :width="7" color="#334666" indeterminate></v-progress-circular>
    </v-overlay>

    <!-- =======================================================
                              Snackbar
    ============================================================-->
    <v-snackbar v-model="snackbar">
      {{ message }}
      <v-spacer />
      <template v-slot:action="{ attrs }">
        <v-btn color="#114979" text v-bind="attrs" @click="snackbar = false">Fechar</v-btn>
      </template>
    </v-snackbar>

    <main class="login">
      <div class="container login__inner">
        <router-link to="/" class="login__brand" aria-label="SEEB Uberlândia, página inicial">
          <img src="@/assets/logo_white.svg" alt="SEEB Uberlândia" width="120" height="129" />
        </router-link>

        <!-- Entrar -->
        <section v-if="!forgotPassword && !alterPassword" class="login__card" aria-labelledby="login-title">
          <h1 id="login-title" class="login__title">Entrar</h1>
          <p class="login__text">Acesse a área administrativa do sindicato.</p>

          <v-text-field v-model="user.email" label="E-mail" type="email" autocomplete="username" required outlined dense></v-text-field>
          <v-text-field v-model="user.password" type="password" label="Senha" autocomplete="current-password" outlined dense required></v-text-field>

          <v-btn block depressed class="login__primary" @click="login">Entrar</v-btn>
          <v-btn text class="login__secondary" @click="forgotPassword = true">Esqueci a senha</v-btn>
        </section>

        <!-- Esqueci a senha -->
        <section v-if="forgotPassword && !alterPassword" class="login__card" aria-labelledby="forgot-title">
          <h1 id="forgot-title" class="login__title">Esqueci minha senha</h1>
          <p class="login__text">Informe seu e-mail para receber as instruções.</p>

          <v-text-field v-model="user.email" label="E-mail" type="email" required outlined dense></v-text-field>

          <v-btn block depressed class="login__primary" @click="forgotPasswordSend">Enviar</v-btn>
          <v-btn text class="login__secondary" @click="forgotPassword = !forgotPassword">Voltar</v-btn>
        </section>

        <!-- Alterar senha -->
        <section v-if="alterPassword && !forgotPassword" class="login__card" aria-labelledby="alter-title">
          <h1 id="alter-title" class="login__title">Alterar senha</h1>
          <p class="login__text">Escolha uma nova senha para a sua conta.</p>

          <v-text-field v-model="password" type="password" label="Nova senha" autocomplete="new-password" required outlined dense></v-text-field>

          <v-btn block depressed class="login__primary" @click="resetPasswordSend">Confirmar</v-btn>
          <v-btn text class="login__secondary" @click="alterPassword = false">Sair</v-btn>
        </section>

        <router-link to="/" class="login__back">Voltar ao site</router-link>
      </div>
    </main>
  </v-app>
</template>

<script>
import userService from "../../service/userService";

export default {
  name: "Login",
  data() {
    return {
      forgotPassword: false,
      alterPassword: false,
      snackbar: false,
      overlay: false,
      password: '',
      message: '',
      user: {
        email: "",
        password: ""
      }
    };
  },
  methods: {
    login() {
      userService.login(this.user).then(res => {

        if (res.data.message) {
          this.message = res.data.message
          this.snackbar = true
        } else {
          this.$router.push({ path: `/cms` })
        }

      });
    },
    forgotPasswordSend() {
      this.overlay = true
      userService.recoverPassword({ email: this.user.email }).then(res => {

        if (res.data.message) {
          this.message = res.data.message
          this.snackbar = true
          this.forgotPassword = false
          this.overlay = false
        }

      }).catch(error => {
        this.overlay = false
      });
    },
    resetPasswordSend() {

      if (this.token) {

        userService.resetPassword({ token: this.token, password: this.password }).then(res => {

          if (res.data.message) {
            this.message = res.data.message
            this.snackbar = true
            this.alterPassword = false
          }
        });
      }
    }
  },
  mounted() {
    this.token = this.$route.params.token
    if (this.token) {
      this.alterPassword = true
    }

  }
};
</script>

<style lang="scss" scoped>
// Mesmo padrão visual do site público: fundo claro, cartão branco, serifa navy e ação laranja.
.login {
  min-height: 100vh;
  display: flex;
  align-items: center;
  padding: 40px 0;
  background: var(--c-navy);

  &__inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    width: 100%;
    max-width: 440px;
  }

  &__back {
    font-size: var(--fs-small);
    font-weight: 600;
    color: #fff;
    text-decoration: underline;
    text-decoration-color: rgba(255, 255, 255, 0.5);
    text-underline-offset: 4px;
  }

  &__brand img {
    display: block;
    height: 120px;
    width: auto;
  }

  &__card {
    width: 100%;
    padding: 40px 36px 32px;
    background: var(--c-surface);
    border: 1px solid var(--c-line);
    border-radius: var(--radius);
  }

  &__title {
    margin: 0 0 8px;
    font-family: var(--font-display);
    font-weight: 500;
    font-size: var(--fs-h3);
    line-height: 1.15;
    color: var(--c-navy);
  }

  &__text {
    margin: 0 0 28px;
    font-size: var(--fs-small);
    line-height: 1.5;
    color: var(--c-muted);
  }

  &__primary.v-btn {
    margin-top: 8px;
    min-height: 48px;
    background: var(--c-orange) !important;
    color: var(--c-ink) !important;
    font-family: var(--font-text);
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 0;
    text-transform: none;
    border-radius: var(--radius-sm);
  }

  &__secondary.v-btn {
    margin-top: 12px;
    width: 100%;
    color: var(--c-navy-deep) !important;
    font-family: var(--font-text);
    font-size: var(--fs-small);
    font-weight: 600;
    letter-spacing: 0;
    text-transform: none;
  }
}

@media (max-width: 480px) {
  .login__card {
    padding: 32px 24px 24px;
  }
}
</style>
